import { connect } from 'react-redux';
import { useSiteContext, useTranslation } from '@eti/providers';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { CANCELLATION_INSURANCE_COVER_GENIUS } from '../../products';
import { useProductData } from '../../common/hook/useProductData';
import NewSmallCardLayout from '../../common/components/small-card-layout/NewSmallCardLayout';
import { concatenateCoverGeniusTexts } from '../../common/utils/coverGeniusApiTexts';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POST_BOOKING_LAYOUT
} = ProductCardLayoutType;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CANCELLATION_INSURANCE_COVER_GENIUS;
const sharedTexts = {
  ipidPolicyLinkText: 'coverGeniusIPIDPolicyLinkText',
  policyLinkText: 'coverGeniusPolicyLinkText',
  readMoreContent: 'cancellationInsuranceCoverGeniusAdditionalInformation',
  title: 'cancellationInsuranceCoverGeniusTitle'
};
const translations = {
  [MAIN_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'cancellationInsuranceCoverGeniusAbstractText',
    upSell: 'cancellationInsuranceCoverGeniusUpSellText'
  },
  [POST_BOOKING_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'cancellationInsuranceCoverGeniusAbstractText',
    upSell: 'cancellationInsuranceCoverGeniusUpSellText'
  },
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'cancellationInsuranceCoverGeniusAbstractSmallCard',
    upSell: 'cancellationInsuranceCoverGeniusUpSellTextSmallCard'
  }
};
const CancellationInsuranceCoverGenius = _ref => {
  let {
    className,
    form,
    isSelected,
    order,
    sellSpecification,
    productPosition,
    productSpecificTexts,
    layoutType = ProductCardLayoutType.Main
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    market
  } = useSiteContext();
  const texts = translations[layoutType] || {};
  const isInUSMarket = market.code === 'US';
  const isInUKMarket = market.code === 'GB';
  const {
    productData,
    rootElement,
    translation: {
      policyLinkText,
      ipidPolicyLinkText,
      readMoreContent,
      abstractContent
    }
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    sellSpecification,
    texts
  });
  if (!productData) {
    return null;
  }
  const isSmallCardLayout = layoutType === ProductCardLayoutType.Small;
  const {
    disclaimer,
    ipid,
    termsUrl = ''
  } = productSpecificTexts || {};
  const terms = {
    url: termsUrl,
    text: policyLinkText
  };
  const ipidPolicy = {
    url: ipid === null || ipid === void 0 ? void 0 : ipid.url,
    text: ipidPolicyLinkText
  };
  const coverGeniusLinks = concatenateCoverGeniusTexts({
    disclaimer: isInUSMarket && !isSmallCardLayout ? disclaimer : undefined,
    ipidPolicy: isInUKMarket || isInUSMarket ? ipidPolicy : undefined,
    terms: isInUKMarket || isInUSMarket ? terms : undefined,
    isInUSOrUKMarket: isInUSMarket || isInUKMarket,
    layoutType,
    t
  });
  const readMoreContentCoverGenius = concatenateCoverGeniusTexts({
    ipidPolicy: !(isInUKMarket || isInUSMarket) ? ipidPolicy : undefined,
    terms: !(isInUKMarket || isInUSMarket) ? terms : undefined,
    disclaimer: !isInUSMarket || isSmallCardLayout ? disclaimer : undefined
  });
  const coverGeniousLinks = isSmallCardLayout ? {
    description: `${abstractContent} ${coverGeniusLinks}`
  } : {
    additionalInformation: coverGeniusLinks
  };
  const updatedProductData = {
    ...productData,
    ...coverGeniousLinks,
    readMoreContent: readMoreContent + readMoreContentCoverGenius
  };
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(NewSmallCardLayout, {
        productData: updatedProductData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: updatedProductData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    isSelected: getSelected(CANCELLATION_INSURANCE_COVER_GENIUS.name, form)(state)
  };
};
export default connect(mapStateToProps)(CancellationInsuranceCoverGenius);
//# sourceMappingURL=CancellationInsuranceCoverGenius.js.map